import { render, staticRenderFns } from "./DeactiveProposals.vue?vue&type=template&id=5f382a28&"
import script from "./DeactiveProposals.vue?vue&type=script&lang=js&"
export * from "./DeactiveProposals.vue?vue&type=script&lang=js&"
import style0 from "./DeactiveProposals.vue?vue&type=style&index=0&id=5f382a28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports